import React, { useState, useEffect } from 'react';
import apiService from '../services/api';
import './Features.css';

const Features = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    try {
      setLoading(true);
      const response = await apiService.getFeatures();
      setFeatures(response.filter((feature) => feature.is_active));
    } catch (err) {
      setError('Failed to load features');
      console.error('Error fetching features:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className='features'>
        <div className='features-container'>
          <div className='responsive-loading'>
            <div className='responsive-spinner' />
            <p>Loading Features...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='features'>
        <div className='features-container'>
          <div className='error-message'>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='features'>
      <div className='features-container'>
        <div className='features-header'>
          <h1>Our Features</h1>
          <p>Discover what makes us different</p>
        </div>

        <div className='features-grid'>
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className='feature-card'
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className='feature-image'>
                {feature.image_url ? (
                  <img
                    src={
                      feature.image_url.startsWith('http')
                        ? feature.image_url
                        : `${process.env.REACT_APP_API_URL_WITH_OUT_API}${feature.image_url}`
                    }
                    alt={feature.title}
                    crossOrigin='anonymous'
                  />
                ) : null}
              </div>

              <div className='feature-content'>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
